import { URLs } from '@/config'

const getters = {
    PAGE_INFO: state => {
        let drawer = state.leftPageDrawer,
            top = null,
            left = null,
            topAppBar = false

        if (state.pageStatus) {
            switch (state.pageStatus) {
                case 'SeniorDashboard': //고객관리
                    top = 'SeniorMenu'
                    left = 'SeniorList'
                    topAppBar = true
                    break
                case 'RecipientDashboard': //수급자
                    top = 'RecipientMenu'
                    left = 'RecipientList'
                    topAppBar = true
                    break
                case 'EmployeeDashboard': //직원
                    top = 'EmployeeMenu'
                    left = 'EmployeeList'
                    topAppBar = true
                    break
                case 'BranchDashboard': //기관운영설정
                    top = null
                    left = 'SettingList'
                    topAppBar = false
                    break
                case 'FinancialDashboard': // 재무회계 (W4C)
                    //left = 'FinancialList'
                    top = 'FinancialMenu'
                    left = null
                    topAppBar = true
                    break
                case 'AuthorizationDashboard': // 전자결재
                    top = 'AuthorizationMenu'
                    left = 'AuthorizationList'
                    topAppBar = true
                    break
                case 'MainTimelineSheet' || 'MainMonthSheet': //타임라인,캘린더 선택
                    top = left = null
                    topAppBar = false
                    break
                case 'MyAccount': // 나의 정보
                    top = left = null
                    topAppBar = false
                    break
                case 'MainDashboard': // Main Dashboard
                    top = left = null
                    topAppBar = false
                    break
            }
        } else {
            top = left = null
            drawer = topAppBar = false
        }

        return {
            drawer: drawer,
            topMenu: top,
            leftList: left,
            topAppBar: topAppBar,
        }
    },
    SUB_NAVI_INFO: state => {
        return {
            drawer: state.subNaviStatus,
            page: state.subNaviPage,
        }
    },
    EXTRA_INFO: state => {
        let drawer = false,
            right = null,
            title = ''

        if (state.extraStatus) {
            switch (state.extraStatus) {
                /* 
                    // TODO: 아래의 내용 점검
                    right = state.extraStatus
                    drawer = true+
                    하지 않고 아래와 같이 코딩을 한 이유는 무엇일까요?
                */
                case 'MainSns': // SNS 정보
                    right = 'MainSns'
                    title = '티타임(소식지)'
                    drawer = true
                    break
                case 'MainAlarm': // Alarm 정보
                    right = 'MainAlarm'
                    title = '알림'
                    drawer = true
                    break
                case 'MainContact': // Alarm 정보
                    right = 'MainContact'
                    title = '상태변화기록지'
                    drawer = true
                    break
                case 'MainChat': // Alarm 정보
                    right = 'MainChat'
                    title = '직원채팅'
                    drawer = true
                    break
                case 'MoreInfo': // more and more 정보
                    right = 'MoreInfo'
                    title = '추가정보'
                    drawer = true
                    break
                case 'Default': // same with default
                default:
                    right = ''
                    title = '기본닫힘'
                    drawer = false
            }
        }

        return {
            drawer: drawer,
            title: title,
            rightInfo: right,
            page: state.extraPageName
        }
    },
    SYSTEM_BAR_INFO: state => {
        return {
            status: state.sysBarStatus,
            message: state.sysBarMessage,
            color: state.sysBarColor,
            inset: state.sysBarInset,
        }
    },
    PAGE_VIEW_TYPE: state => {
        return state.pageViewType
    },
    CURRENT_BRANCH: state => {
        if (state.allBranch && state.cbidx) {
            if (state.allBranch) {
                let arr = state.allBranch.filter(item => item.customerBranchIdx === state.cbidx)
                return arr[0]
            } else {
                return null
            }
        } else {
            return null
        }
    },
    USER_INFO: state => {
        return {
            brief: state.userInfo,
            permission: state.permissionInfo,
            branch: state.allBranch
        }
    },
    MY_SIGN_URL: state => {
        if (state.mySign) {
            return `${URLs.display}/${state.mySign.digitalSignatureFileIdx}`
        } else {
            return null
        }
    },
    MY_SIGN_IDX: state => {
        if (state.mySign) {
            return state.mySign.digitalSignatureIdx
        } else {
            return null
        }
    },
    PERSON_SIGN_URL: state => {
        if (state.thirdPersonSign) {
            return `${URLs.display}/${state.thirdPersonSign.digitalSignatureFileIdx}`
        } else {
            return null
        }
    },
    PERSON_SIGN_IDX: state => {
        if (state.thirdPersonSign) {
            return state.thirdPersonSign.digitalSignatureIdx
        } else {
            return null
        }
    },
    PERSON_SIGNATURE: state => {
        if (state.thirdPersonSign) {
            return state.thirdPersonSign
        } else {
            return null
        }
    },
    BRANCH_OFFICE_SEAL: state => {
        if (state.branchOfficeSeal && state.branchOfficeSeal.officeSealFileIdx) {
            return `${URLs.display}/${state.branchOfficeSeal.officeSealFileIdx}`
        } else {
            return null
        }
    },
    CONTRACT_PRINT_NO: state => {
        return state.showPrintContractNo
    },
    SMS_REMAIN_COUNT: state => {
        let count = 0
        if (state.remainInfo) {
            count = state.remainInfo.remainCount
        }
        return count
    },
    FILTER_SMS_USER: state => {
        if (state.userFilter) {
            let arr = null
            if (state.userFilter !== '직원전체') {
                arr = state.smsUserList.filter(item => item.userType === state.userFilter)
            } else {
                arr = state.smsUserList.filter(item => item.userType === '시설장' || item.userType === '관리책임자' ||
                    item.userType === '사회복지사' || item.userType === '간호사' || item.userType === '요양보호사')
            }
            return arr
        } else {
            return state.smsUserList
        }
    },
    COMMON_HOLIDAY_YMD: state => {
        let arr = []
        if(state.commonHoliday) {
            state.commonHoliday.forEach(item => {
                arr.push(item.ymd)
            })
        }

        return arr
    },
    BUSINESS_DAY_YMD: state => {
        let arr = []
        if(state.businessDay) {
            state.businessDay.forEach(item => {
                arr.push(item.ymd)
            })
        }
        return arr
    }
}

export default getters;


// WEBPACK FOOTER //
// ./src/store/default/getters.js